import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import storage from '../../lib/storage'
import { STATUS_LIVE } from '../../utils/constants'

import { validateSecureAccess } from '../../lib/api'
import { loadExamSource } from '../../utils/load-exam-source'
import Player from '../../components/player'
import Expired from './expired'

const StyledContainer = styled.div`
  height: 100%;
  width: 100%;
  background-color: black;
`

const SecureAccess = () => {
    const { t } = useTranslation()
    const [searchParams] = useSearchParams()
    const token = searchParams.get('token')
    const [patient, setPatient] = useState()
    const [expired, setExpired] = useState(!token)

    useEffect(() => {
        if (!token) return
        startingRequests()
    }, [token])

    const redirect = (url) => {
        if (typeof window !== 'undefined' && url) {
            window.location.href = url
        }
    }

    const startingRequests = async () => {
        try {
            const { data } = await validateSecureAccess(token)
            storage.saveSession(data)
            const result = await loadExamSource()
            if (!result) return
            if (result.paymentRedirect) {
                redirect(result.paymentRedirect)
                return
            }
            setPatient(result.patient)
        } catch (error) {
            console.error('secure-access validate error', error)
            setExpired(true)
        }
    }

    if (expired) {
        return <Expired />
    }

    return (
        <StyledContainer>
            {patient ? (
                <Player
                    options={{
                        sources: [
                            { src: patient.intro, type: 'video/mp4' },
                            { src: patient.src, type: patient.type },
                        ],
                    }}
                    isLive={patient.examStatus === STATUS_LIVE}
                    hlsjsConfig={{ maxMaxBufferLength: 12 }}
                />
            ) : (
                <p style={{ color: 'white', padding: 16 }}>{t('loading')}</p>
            )}
        </StyledContainer>
    )
}

export default SecureAccess
